module.exports = __webpack_public_path__ + "static/img/bg-ar.a03a0443.png";